











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CargaCorreios} from '@/model/resource/CargaCorreios'
import {CargaCorreiosCollection} from '@/model/collection/CargaCorreiosCollection'
import {ListCargaCorreiosSchema} from '@/schema/resource/CargaCorreios/ListCargaCorreiosSchema'
import {CsvCargaCorreiosSchema} from '@/schema/resource/CargaCorreios/CsvCargaCorreiosSchema'

@Component
export default class ListCargaCorreiosView extends Mixins(MixinQueryRouter) {
  schema = new ListCargaCorreiosSchema()
  collection = new CargaCorreiosCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CargaCorreios) {
    Helper.pushByName('editCargaCorreios', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CargaCorreiosCollection().clearFilters().addFilter(params)

    await csv.listCsvCargaCorreios()
    new CsvCargaCorreiosSchema().downloadCsv(csv.all())
  }
}
